import React, {Component} from 'react'

class RelatedTag extends Component {

    constructor(props) {
        super()

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(newkeyword) {
        this.props.history.push('/search?keyword='+newkeyword)
        return this.props.refresh()
    }


    render(){
        var renderrelatedtaglist 
        
        if(0 < this.props.relatedtaglist.length) {
            renderrelatedtaglist = (
                <>
                    <div className="title">Penelusuran yang terkait</div>
                    {this.props.relatedtaglist.map(tag => {
                        return <div className="list" key={tag.TagID}><span onClick={() => this.handleClick(tag.Tag)}>{tag.Tag}</span></div>
                    })}
                </>
            )
        } else {
            return ''
        }

        return(
            <div className="related">
                {renderrelatedtaglist}
            </div>
        )
    }
}

export default RelatedTag